import dynamic from "next/dynamic";
import type { SubscriptionButtonProps } from "scmp-sdk";

export const DynamicSubscriptionButton = dynamic<SubscriptionButtonProps>(() =>
  import("scmp-sdk").then(module => module.SubscriptionButton),
);
